import { useTranslation } from 'react-i18next'
import SearchBar from '@/common/SearchBar'

interface Props {
  isFetching?: boolean
}

export default function TempleSearchInput({ isFetching }: Props) {
  const { t } = useTranslation(['frame'])

  return (
    <SearchBar
      label={t('frame:temple.search.input.label')}
      placeholder={t('frame:temple.search.input.placeholder')}
      isFetching={isFetching}
    />
  )
}
